import { render, staticRenderFns } from "./EmailActions.vue?vue&type=template&id=544c8b8f&scoped=true"
import script from "./EmailActions.vue?vue&type=script&lang=js"
export * from "./EmailActions.vue?vue&type=script&lang=js"
import style0 from "./EmailActions.vue?vue&type=style&index=0&id=544c8b8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544c8b8f",
  null
  
)

export default component.exports